import { forwardRef } from 'react'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  input: {
    backgroundColor: '#fff',
    border: '1px solid hsl(0, 0%, 80%)',
    borderRadius: '4px',
    paddingLeft: '10px',
    outlineColor: '#fff',
  }
}))

const PhoneInput = (props, ref) => {
  const classes = useStyles()

  return (

    <TextField
      {...props}
      InputProps={{
        className: classes.input
      }}
      inputRef={ref}
      size='medium'
      variant='standard'
      name='phone'
      placeholder='1234567890'
    />
  )
}
export default forwardRef(PhoneInput)